import { AuthProviderProps } from 'oidc-react';
import { ENV } from 'src/config/env';

export const OIDC_CONF: AuthProviderProps = {
    onSignIn: async () => {
        window.location.hash = '';
    },
    authority: ENV.oidcAuthority,
    clientId: 'lmnt-web',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    scope: 'openid profile email api jsf',
    autoSignIn: false,
    automaticSilentRenew: true,
    responseType: 'code',
    loadUserInfo: true,
};
